require('./bootstrap');

// Slick
require('slick-carousel/slick/slick.min')

// AOS
import AOS from 'aos';

AOS.init();
